var map = {
	"./arrow_back_white.svg": "9VYR",
	"./backspace.svg": "FTuk",
	"./badge.svg": "61+i",
	"./bebidas.svg": "QAvW",
	"./btn-carrinho.svg": "VEU/",
	"./burgers.svg": "vayn",
	"./change_black.svg": "pdSV",
	"./change_white.svg": "M64A",
	"./close_black.svg": "7y0p",
	"./close_white.svg": "hgdO",
	"./conect_white.svg": "kXjD",
	"./delete_white.svg": "nZ2y",
	"./edit_white.svg": "AEPV",
	"./entradas.svg": "inIU",
	"./faceRecognition.svg": "2w5G",
	"./junk-icon.svg": "ZIsg",
	"./minus_black.svg": "Y5y7",
	"./minus_white.svg": "8fPA",
	"./money_white.svg": "DRFC",
	"./password.svg": "jXxz",
	"./paste.svg": "wc0S",
	"./plus_black.svg": "ejmC",
	"./plus_white.svg": "k8gf",
	"./print_white.svg": "ZVuB",
	"./report_problem.svg": "b25/",
	"./shift-fill.svg": "8hzy",
	"./shift.svg": "TG2b",
	"./shopping_cart_black.svg": "ePl+",
	"./shopping_cart_white.svg": "sFdA",
	"./taa-horizontal-colorida.svg": "pklk",
	"./tef.svg": "P7ok"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "x3md";


//////////////////
// WEBPACK FOOTER
// ./static/icons ^\.\/.*\.svg$
// module id = x3md
// module chunks = 1